/**
 * @generated SignedSource<<f7635b0e6e5735d76e47e855a5f35d2f>>
 * @relayHash 55924df0b6c78853b0eb4cc2cb9e11ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 36eed5b7f382fc4a11845a1a14c68f62f8795484b622eb70cf44b807e57ee54c

import type { ConcreteRequest } from 'relay-runtime';
export type useAttachmentsPageByTitleQuery$variables = {
  hasSplit: boolean;
  rawSpaceKey: string;
  rawTitle: string;
  splitSpaceKey: string;
  splitTitle: string;
};
export type useAttachmentsPageByTitleQuery$data = {
  readonly rawContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly splitContent?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
};
export type useAttachmentsPageByTitleQuery = {
  response: useAttachmentsPageByTitleQuery$data;
  variables: useAttachmentsPageByTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSplit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawSpaceKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawTitle"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "splitSpaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "splitTitle"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v6 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ]
  }
],
v7 = [
  {
    "alias": "rawContent",
    "args": [
      (v5/*: any*/),
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "rawSpaceKey"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "rawTitle"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "condition": "hasSplit",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "splitContent",
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "splitSpaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "splitTitle"
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v6/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAttachmentsPageByTitleQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAttachmentsPageByTitleQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "55924df0b6c78853b0eb4cc2cb9e11ac",
    "id": "36eed5b7f382fc4a11845a1a14c68f62f8795484b622eb70cf44b807e57ee54c",
    "metadata": {},
    "name": "useAttachmentsPageByTitleQuery",
    "operationKind": "query",
    "text": "query useAttachmentsPageByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$splitSpaceKey:String!,$splitTitle:String!,$hasSplit:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,first:1){nodes{id,title}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,first:1)@include(if:$hasSplit){nodes{id,title}}}"
  }
};
})();

(node as any).hash = "0475e2a0f2b864806978d7e16fa5c136";

export default node;
